module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "questionFault"
    }
  }, [_c('div', {
    staticClass: "systerm-classity"
  }, [_c('span', {
    class: {
      'active': _vm.officialAccessories == '1'
    },
    on: {
      "click": function($event) {
        return _vm.handleClickTab('1')
      }
    }
  }, [_vm._v("非官方部件")]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.officialAccessories == '2'
    },
    on: {
      "click": function($event) {
        return _vm.handleClickTab('2')
      }
    }
  }, [_vm._v("官方部件")]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.officialAccessories == '0'
    },
    on: {
      "click": function($event) {
        return _vm.handleClickTab('0')
      }
    }
  }, [_vm._v("更换整机")])]), _vm._v(" "), _c('div', {
    staticClass: "brand container"
  }, [_c('h4', [_vm._v("故障大类")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.faultClassLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "faultClassListPart listPart",
      on: {
        "click": function($event) {
          return _vm.selectFaultClass(item, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.faultTypesName) + "\n        "), _c('span', {
      class: {
        active: _vm.activeIndex === index
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    })])])
  }), 0)]), _vm._v(" "), (_vm.modelClassList && _vm.modelClassList.length > 0) ? [_c('div', {
    staticClass: "brand container"
  }, [_c('h4', [_vm._v("型号")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.modelClassList), function(item, index) {
    return _c('li', {
      key: index + item,
      staticClass: "faultClassListPart listPart",
      on: {
        "click": function($event) {
          return _vm.selectModel(item, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.modelName) + "\n          "), _c('span', {
      class: {
        active: _vm.modelActiveIndex === index
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    })])])
  }), 0)])] : _vm._e(), _vm._v(" "), (_vm.isShowQuestion) ? [_c('div', {
    staticClass: "question container"
  }, [_c('h4', [_vm._v("问题/图片")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [(!_vm.isShowAdd) ? _c('li', {
    staticClass: "faultClassListPart listPart"
  }, [_c('p', [_vm._v(_vm._s(_vm.questionList.particularsProblem))]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "exitBtn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.exitFault()
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), (_vm.fauleAuth.deleFault) ? _c('i', {
    staticClass: "el-icon-error activeDelBtn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleFault()
      }
    }
  }) : _vm._e()])]) : _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.addNewQuestion()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.dislogBrand,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogBrand = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('brandForm')
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "故障分类"
    }
  }, [_vm._v(_vm._s(_vm.questionType))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "问答"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "multiple": ""
    },
    model: {
      value: (_vm.ruleForm.answer),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "answer", $$v)
      },
      expression: "ruleForm.answer"
    }
  }, _vm._l((_vm.allQuestionList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.questionName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请选择图片"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "multiple": ""
    },
    model: {
      value: (_vm.ruleForm.images),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "images", $$v)
      },
      expression: "ruleForm.images"
    }
  }, _vm._l((_vm.picList), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "special-item",
      attrs: {
        "label": item.imageName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pic-list"
  }, _vm._l((_vm.imageList), function(item, index) {
    return _c('img', {
      key: item + index,
      staticClass: "pic",
      attrs: {
        "src": item
      }
    })
  }), 0)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleCancelDialog('ruleForm')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('ruleForm')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-48764a6b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/questionFault.vue
// module id = 1645
// module chunks = 0